import { render, staticRenderFns } from "./OtherProjects.vue?vue&type=template&id=d40943e2&scoped=true&"
import script from "./OtherProjects.vue?vue&type=script&lang=ts&"
export * from "./OtherProjects.vue?vue&type=script&lang=ts&"
import style0 from "./OtherProjects.vue?vue&type=style&index=0&id=d40943e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40943e2",
  null
  
)

export default component.exports